import JSZip from "jszip";

const useDownload = (filename) => {
    async function handleZip(images) {
        const zip = new JSZip();

        const getName = (index) => {
            return index.toString().padStart(3, "0");
        }

        // Add Images to the zip file
        for (let i = 0; i < images.length; i++) {
            //try to download file
            try {
                const response = await fetch(images[i]);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const blob = await response.blob();
                zip.file(
                    `image-${getName(i + 1)}.jpg`,
                    blob
                );
            }
            catch (error) {
                console.error("Error downloading file: ", error);
                continue;
            }
        }

        // Generate the zip file
        const zipData = await zip.generateAsync({
            type: "blob",
            streamFiles: true,
        });

        // Create a download link for the zip file
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(zipData);
        link.download = `${filename ? filename : "images"}.zip`;
        link.click();
    }

    return { handleZip };
};

export { useDownload };